import { render } from "./SearchBody.vue?vue&type=template&id=07fb2c51&scoped=true"
import script from "./SearchBody.vue?vue&type=script&lang=js"
export * from "./SearchBody.vue?vue&type=script&lang=js"

import "./SearchBody.vue?vue&type=style&index=0&id=07fb2c51&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fb2c51"]])

export default __exports__